import React from 'react'
import DOMPurify from 'dompurify'
import { encodeForURL } from '../../../global/formatters/string-formatter.js'

const CarouselCard = ({ slide }) => {
  return (
    <div className="Carousel-slide u-textLeft">
      <img
        width="80"
        height="50"
        className="u-marginBottom4gu"
        src={encodeForURL(slide.image)}
        alt={''}
      />
      <h3 className="Slide-title u-marginBottom2gu u-textColorWhite">
        {slide.heading}
      </h3>
      {slide.body?.map((html, i) => (
        <div
          key={i}
          className="u-marginBottom2gu u-textSecondary"
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
        />
      ))}
    </div>
  )
}

export default CarouselCard
